import { IonPage, IonButton, IonCardContent, IonContent, IonInput, IonItem, IonCard, IonAlert } from '@ionic/react';
import React, {useState, useContext} from 'react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './Auth.css';
import { ServerUrl } from '../../constants';
import { Redirect } from 'react-router-dom';
import { AppContext } from "../../context/appContext";
import { VerifyPassword } from '../../constants';

const CreateAccount: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);

  const [oldpassword, setoldpassword] = useState<string>();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [messageText, setMessageText] = useState<string>('');
  const [registered, setRegistered] = useState(false);

  if (registered) {
    return <Redirect to="/" />
  }

  const onCreateAccount = ()=> {
    var errorMessage = '';
    if (!oldpassword) {
      errorMessage += 'Old password is required.<br>'
    }

    if (!password || !confirmPassword || password !== confirmPassword) {
      errorMessage += 'Password does not match.<br>'
    } else if (!VerifyPassword(password)) {
      errorMessage += 'Password must contain at least one numeric digit and a special character, and has more than 7 characters.<br>'
    }

    if (errorMessage.length > 0) {
      setMessageText(errorMessage);
      return;
    }

    axios.post(`${ServerUrl}/auth/changepassword`, {username: oldpassword, password}, {
      headers: {
        'Authorization': "Bearer " + CurrentUser.token,          
      }
    }).then(res => {
      setRegistered(true);
    }).catch((error) => {
      setMessageText(error.response.data);  
    });

  };

  return(
      <IonPage>
          <Navbar />
          <IonContent>
          <div className='Container'>
            <div className='PageTitle'>Change Password</div>
            <IonCard>
              <IonCardContent>
                <IonItem className="FirstTextInput">
                    <IonInput min='0'  value={oldpassword} placeholder="Old Password" 
                        onIonChange={e => setoldpassword(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <IonItem className="TextInput">
                    <IonInput min='0'  type="password" value={password} placeholder="New Password" 
                        onIonChange={e => setPassword(e.detail.value!)}>
                    </IonInput>
                </IonItem >
                <IonItem className="TextInput">
                    <IonInput min='0'  type="password" value={confirmPassword} placeholder="Confirm New Password" 
                        onIonChange={e => setConfirmPassword(e.detail.value!)}>
                    </IonInput>
                </IonItem>
                <div className='RowCenter'>
                  <IonButton color="primary" style={{textTransform:'none'}} onClick = {onCreateAccount}>Change</IonButton>
                </div>
              </IonCardContent>
            </IonCard>
          </div>
          <IonAlert 
              isOpen={messageText.length > 0} 
              onDidDismiss={()=> setMessageText('')}
              header={'Error'}
              subHeader={''}
              message={messageText}
              buttons={['OK']}
          />
          </IonContent>
      </IonPage>
  );
};

export default CreateAccount;
